import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow, Tooltip } from '@mui/material';
import { Autocomplete, TextField, IconButton } from '@totalsoft/rocket-ui';
import CancelIcon from '@mui/icons-material/Cancel';
import { ParamsContext } from 'providers/ParamsContext';

const CommissionComponent = props => {
  const { index, commission, commissionTypes } = props;
  const { loadDealers, validationInfo, cardName, isSubsidy, visibleColumns, editRight, addOrDeleteRight, calcInProgress } = props;

  const { onCommissionTypeChange, onRemoveCommission, onPercentChange, onAmountChange, onPropertyChange, loadCalculationMethods } = props;

  const { cvsChPercent } = useContext(ParamsContext);
  return (
    <TableRow>
      {visibleColumns.includes('Name') && (
        <TableCell>
          <Autocomplete
            id={cardName + index + isSubsidy ? '_subsidyName' : '_commissionName'}
            fullWidth
            labelKey='commissionName'
            valueKey='commissionId'
            value={commission.commissionId}
            isSearchable={false}
            simpleValue
            isClearable={false}
            onChange={onCommissionTypeChange}
            options={commissionTypes}
            error={Boolean(validationInfo && validationInfo.commissionId)}
            helperText={validationInfo && validationInfo.commissionId}
            disabled={commission.readOnlyYN || commission.documentCommissionId > 0 || !editRight || calcInProgress.inProgress}
          />
        </TableCell>
      )}
      {visibleColumns.includes('CalculationName') && (
        <TableCell>
          <Autocomplete
            id={cardName + index + isSubsidy ? '_subsidyCalculationName' : '_commissionCalculationMethodName'}
            fullWidth
            labelKey='calculationMethodName'
            valueKey='calculationMethodId'
            value={
              !(validationInfo && validationInfo.commissionId) && {
                calculationMethodId: commission.calculationMethodId,
                calculationMethodName: commission.calculationMethodName
              }
            }
            isSearchable={false}
            isClearable={false}
            onChange={onPropertyChange('calculationMethod')}
            loadOptions={loadCalculationMethods}
            disabled={commission.readOnlyYN || !editRight || calcInProgress.inProgress}
          />
        </TableCell>
      )}
      {visibleColumns.includes('Percent') && (
        <TableCell>
          <TextField
            id={cardName + index + isSubsidy ? 'subsidyPercent' : '_commissionPercent'}
            name='percent'
            isNumeric
            value={commission.commissionPercent || commission.commissionPercent === 0 ? commission.commissionPercent : ''}
            onChange={onPercentChange}
            inputProps={{ decimalScale: cvsChPercent }}
            error={Boolean(validationInfo && validationInfo.commissionPercent)}
            helperText={validationInfo && validationInfo.commissionPercent}
            disabled={commission.readOnlyYN || !editRight || calcInProgress.inProgress}
          />
        </TableCell>
      )}
      {visibleColumns.includes('Amount') && (
        <TableCell>
          <TextField
            id={cardName + index + isSubsidy ? 'subsidyAmount' : '_commissionAmount'}
            name='value'
            isNumeric
            value={commission.commissionAmount || commission.commissionAmount === 0 ? commission.commissionAmount : ''}
            onChange={onAmountChange}
            error={Boolean(validationInfo && validationInfo.commissionAmount)}
            helperText={validationInfo && validationInfo.commissionAmount}
            disabled={commission.readOnlyYN || !editRight || calcInProgress.inProgress}
          />
        </TableCell>
      )}
      {visibleColumns.includes('Currency') && (
        <TableCell>
          <TextField id={cardName + index + '_currency'} name='currencyCode' fullWidth value={commission.currencyCode} disabled={true} />
        </TableCell>
      )}
      {visibleColumns.includes('PartnerName') && (
        <Tooltip title={commission.partnerName ? commission.partnerName : ''}>
          <TableCell>
            <Autocomplete
              id={cardName + index + '_partnerName'}
              fullWidth
              cache={false}
              name='partnerId'
              value={{ dealerId: commission.partnerId, name: commission.partnerName }}
              valueKey='dealerId'
              labelKey='name'
              loadOptions={loadDealers}
              onChange={onPropertyChange('partner')}
              isClearable={false}
              disabled={commission.readOnlyYN || !editRight || calcInProgress.inProgress}
            />
          </TableCell>
        </Tooltip>
      )}
      {visibleColumns.includes('FreeTxt') && (
        <TableCell width='30%'>
          <TextField
            id={cardName + index + '_freeTxt'}
            name='notes'
            fullWidth
            disabled={!editRight || calcInProgress.inProgress}
            value={commission.freeTxt}
            onChange={onPropertyChange('freeTxt')}
            inputProps={{ maxLength: 255 }}
          />
        </TableCell>
      )}
      <TableCell>
        <IconButton
          id={cardName + index + '_deleteBtn'}
          color='primary'
          variant='text'
          size='small'
          onClick={onRemoveCommission}
          disabled={commission.mandatory || !editRight || !addOrDeleteRight || calcInProgress.inProgress}
        >
          <CancelIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};
CommissionComponent.propTypes = {
  commission: PropTypes.object.isRequired,
  commissionTypes: PropTypes.array.isRequired,
  onRemove: PropTypes.func.isRequired,
  loadDealers: PropTypes.func.isRequired,
  loadCalculationMethods: PropTypes.func.isRequired,
  validationInfo: PropTypes.object,
  index: PropTypes.number.isRequired,
  cardName: PropTypes.string.isRequired,
  isSubsidy: PropTypes.bool.isRequired,
  visibleColumns: PropTypes.array.isRequired,
  editRight: PropTypes.bool.isRequired,
  addOrDeleteRight: PropTypes.bool.isRequired,
  calcInProgress: PropTypes.bool.isRequired,
  onCommissionTypeChange: PropTypes.func.isRequired,
  onRemoveCommission: PropTypes.func.isRequired,
  onPercentChange: PropTypes.func.isRequired,
  onAmountChange: PropTypes.func.isRequired,
  onPropertyChange: PropTypes.func.isRequired
};

CommissionComponent.displayName = 'CommissionComponent';

export default CommissionComponent;
